// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"CV-z","sponsoredTooltipWrapper":"DV-z","sponsoredTooltip":"EV-z","newCard":"FV-z"};